import { Skeleton } from '@radix-ui/themes'

const IntegrationSkeleton = () => {
  return (
    <div className="w-full flex h-screen p-4 gap-4">
      {/* Col 1 */}
      <div className="flex w-1/5 space-x-4 mb-2 justify-between">
        <div className="flex flex-col w-full gap-2">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
          <div className="h-1 w-full flex-grow" />
        </div>
      </div>
      {/* Col 2 */}
      <div className="flex space-x-4 flex-grow h-[80%] pr-8">
        <div className="flex flex-col w-full gap-2">
          <Skeleton className="h-1/3" />
          <Skeleton className="h-1/3" />
          <Skeleton className="h-1/3" />
          <Skeleton className="h-1/3" />
        </div>
        <div className="flex flex-col w-full gap-2">
          <Skeleton className="h-1/3" />
          <Skeleton className="h-1/3" />
          <Skeleton className="h-1/3" />
          <Skeleton className="h-1/3" />
        </div>
        <div className="flex flex-col w-full gap-2">
          <Skeleton className="h-1/3" />
          <Skeleton className="h-1/3" />
          <Skeleton className="h-1/3" />
          <Skeleton className="h-1/3" />
        </div>
      </div>
    </div>
  )
}

export default IntegrationSkeleton
